// components
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Knob } from "react-rotary-knob";
import { Avatar, Box, Typography } from "@material-ui/core";
import { Grid, Slider } from "@mui/material";
import UpDownButton from "components/shared/UpDownButton";
import * as skins from "react-rotary-knob-skin-pack";

//assetes
import layerBack from "assets/images/vocal_controls_back.png";
// import volumeKnobSkin from "assets/knobSkins/volume"
import volumeKnobSkin from "assets/knobSkins/vocalVolume";
import pannerKnob from "assets/knobSkins/phase2panner";
import filterKnob from "assets/knobSkins/phase2filter";
import vocal_on from "assets/images/vocal_on.png";
import vocal_off from "assets/images/vocal_off.png";
import pannerNumbers from "assets/images/pannerNumbers.png";
import hallIR from "assets/effects/irHall.ogg";
import telephoneIR from "assets/effects/telephone.wav";

import muteButtonOff from "assets/phase2/3_off.png";
import muteButtonOn from "assets/phase2/3_on.png";
import soloButtonOff from "assets/phase2/4_off.png";
import soloButtonOn from "assets/phase2/4_on.png";
import filterResetBtn from "assets/phase2/14.png";
import sliderBaseBackground from "assets/phase2/5.png";
import sliderSlide from "assets/phase2/6.png";


const useStyles = makeStyles((theme) => ({
  layerContainer: {
    left: "4%",
    height: "95%",
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    // backgroundImage: `url(${layerBack})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    // marginTop:"-8%"
  },
  toggleButton: {
    position: "relative",
    top: "10%",
    left: "20%",
    width: "60%",
    height: "60%",
  },
  toggleButtonHorizontal: {
    position: "relative",
    top: "10%",
    left: "20%",
    width: "50%",
    height: "50%",
    // transform:"rotate(90deg)",
  },
  toggleButtonImage: {
    width: "100%",
    height: "100%",
    display: "inline-block",
  },
  layerNameTYpography: {
    position: "relative",
    // top: "5.5vw",
    // left: "-1vw",
    fontSize: "5px",
    left: "1%",
    top: "1%",
    textAlign: "center",
  },
  knobGrid: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
  },
  muteControlButton: {
    top: "15%",
    left: "10%",
    height: "80%",
    position: "relative",
  },
  panner: {
    width: "100%",
    height: "21.43%",
    // backgroundColor: "cyan",
  },
  muteBox: {
    width: "100%",
    height: "14.28%",
    // paddingLeft:"10%",
    // backgroundColor: "limegreen",
  },
  slider: {
    width: "100%",
    height: "64.29%",
    justifyContent: "center",
    // backgroundColor: "lightsalmon",
  },
  sliderBase: {
    width: "85%",
    backgroundImage: `url(${sliderBaseBackground})`,
    // backgroundSize: "cover",
    // backgroundRepeat: "no-repeat",
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: "8%",
    paddingTop: "5%",
  },
  sliderSlide: {
    width: "60%",
    left: "10%",
    position: "relative",
    backgroundImage: `url(${sliderSlide})`,
    // backgroundSize: "cover",
    // backgroundRepeat: "no-repeat",
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  fullContainer: {
    height: "100%",
    width: "100%",
  },
  filterResetBtn: {
    width: "90%",
    height: "80%",
    position: "relative",
    left: "5%",
    backgroundImage: `url(${filterResetBtn})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  }
}));

/**
 * @component VocalControler
 */
const VocalControl = forwardRef(
  (
    {
      mergerNodeReference,
      audioContextInstance,
      name,
      layerId,
      initialVolume,
      initialPanning,
      src,
      initialMuted,
      layerNumber,
      muteSideEffectFunction,
      announceCurrentPortion,
      stateChanger,
      currentTrackNumber,
      soloSideEffectFunction,
      initialSolo,
      selected,
      handelSelectionFunction,
      layerPosition,
      isDecorative
    },
    ref
  ) => {
    const [volume, setVolume] = useState(initialVolume);
    const [panning, setPanning] = useState(initialPanning);
    const [muted, setMuted] = useState(initialMuted);
    const [audioElement, setAudioElement] = useState(null);
    const [biquadFilter1Instance, setBiquadFilter1] = useState(null);
    const [biquadFilter2Instance, setBiquadFilter2] = useState(null);
    const [convolverNode1Instance, setConvolverNode1] = useState(null);
    const [convolverNode2Instance, setConvolverNode2] = useState(null);
    const [reverbGainNode, setReverbGainNode] = useState(null);
    const [telephoneGainNode, setTelephoneGainNode] = useState(null);
    const [telephoneMute, setTelephoneMute] = useState(true);
    const [reverbValue, setReverbValue] = useState(0);
    const [lowpassFrequency, setLowpassFrequency] = useState(20000);
    const [highpassFrequency, setHighpassFrequency] = useState(0);
    const [pannerNode, setPannerNode] = useState(null);
    const [currentTrack, setCurrentTrack] = useState(currentTrackNumber);
    const [selectedState, setSelectedState] = useState(selected);
    const [solo, setSolo] = useState(initialSolo);
    const classes = useStyles();

    const [playerState, setPlayerState] = useState("waitingToPlay");

    const timestamps = [
      0, 18, 34, 50, 66, 82, 98, 114, 130, 146, 162, 178, 210, 242, 258, 290,
      306, 322, 338, 354, 370, 402, 434, 466, 474, 490, 498, 514, 530, 546, 562,
      578, 594, 610,
    ];

    const handelMute = () => {
      audioElement.volume = muted ? volume : 0;
      setMuted(!muted);
      muteSideEffectFunction(layerId);
    };

    const handelSolo = () => {
      if (muted) handelMute();
      setSolo(!solo);
      soloSideEffectFunction(layerId);
    };

    const handelReverb = (newValue) => {
      // console.log("reverb mute:", reverbMute);
      reverbGainNode.gain.setValueAtTime(
        newValue/100,
        audioContextInstance.currentTime
      );
      setReverbValue(newValue/100);
    };
    const handelTelephone = () => {
      // console.log("telephone mute:", telephoneMute);
      telephoneGainNode.gain.setValueAtTime(
        telephoneMute ? 1 : 0,
        audioContextInstance.currentTime
      );
      setTelephoneMute(!telephoneMute);
    };

    const handelVolumeChange = (newVolume) => {
      audioElement.volume = muted ? 0 : newVolume;
      setVolume(newVolume);
    };
    const handelPanningChange = (newPan) => {
      pannerNode.pan.value = newPan;
      setPanning(newPan);
    };

    useImperativeHandle(ref, () => ({
      play() {
        audioContextInstance.resume();
        audioElement.play();
      },
      pause() {
        audioElement.pause();
      },
      stop() {
        // audioElement.pause();
        // audioElement.currentTime = trackEndTime;
        stateChanger(name, "readyToPlay");
        setCurrentTrack((currentTrack) => currentTrack + 1);
      },
      toggleMute() {
        handelMute();
      },
      setMute(muteState) {
        if (muteState !== muted) handelMute();
      },
      changePlaybackSpeed(newSpeed) {
        if(!audioElement) return;
        audioElement.playbackRate = newSpeed;
      },
      changeCurrentTime(newPortion) {
        audioElement.currentTime = newPortion * audioElement.duration;
      },
      deselect(){
        setSelectedState(false)
      }
    }));

    useEffect(() => {
      let audioElementInstace = document.querySelector(`#${name}`);
      
      audioElementInstace.addEventListener("timeupdate", () => {
        if (
          isNaN(audioElementInstace.duration) ||
          isNaN(audioElementInstace.currentTime)
        )
          return 0;
        let index = timestamps.filter(
          (element) => element < audioElementInstace.currentTime
        ).length;
        let trackStartTime = timestamps[index - 1];
        let trackEndTime = timestamps[index];

        announceCurrentPortion(
          (audioElementInstace.currentTime - trackStartTime) /
            (trackEndTime - trackStartTime)
        );
        if (audioElementInstace.currentTime >= trackEndTime) {
          audioElementInstace.pause();
          stateChanger(name, "ended");
        }
      });

      audioElementInstace.addEventListener("waiting", () => {
        // console.log(name, "starts to wait", audioElementInstace.currentTime);
        stateChanger(name, "waiting");
      });
      audioElementInstace.addEventListener("canplaythrough", () => {
        // console.log(
        //   name,
        //   "starts to play again",
        //   audioElementInstace.currentTime
        // );
        stateChanger(name, "readyToPlay");
      });
      // audioElementInstace.addEventListener("load",()=>{
      //   console.log(name,"loads for the first time", audioElementInstace.currentTime)
      //   stateChanger(name,"readyToPlay")
      // })
      audioElementInstace.addEventListener("ended", () => {
        stateChanger(name, "ended");
      });

      setAudioElement(audioElementInstace);
      let audioTrack =
        audioContextInstance.createMediaElementSource(audioElementInstace);

      audioTrack.connect(mergerNodeReference, 0, layerNumber);

      let biquadFilter1 = audioContextInstance.createBiquadFilter();
      biquadFilter1.type = "lowpass";
      biquadFilter1.frequency.value = lowpassFrequency;
      setBiquadFilter1(biquadFilter1);
      audioTrack.connect(biquadFilter1);

      let biquadFilter2 = audioContextInstance.createBiquadFilter();
      biquadFilter2.type = "highpass";
      biquadFilter2.frequency.value = highpassFrequency;
      setBiquadFilter2(biquadFilter2);
      biquadFilter1.connect(biquadFilter2);

      let convolverNode1 = audioContextInstance.createConvolver();
      fetch(hallIR).then((res) => {
        res.arrayBuffer().then((arrayBuffer) => {
          audioContextInstance
            .decodeAudioData(arrayBuffer)
            .then((decodedBuffer) => (convolverNode1.buffer = decodedBuffer));
        });
      });
      setConvolverNode1(convolverNode1);

      let reverbMergerNode = audioContextInstance.createChannelMerger(2);
      biquadFilter2.connect(convolverNode1);

      let reverbGainNode = audioContextInstance.createGain();
      reverbGainNode.gain.setValueAtTime(0, audioContextInstance.currentTime);
      setReverbGainNode(reverbGainNode);

      convolverNode1.connect(reverbGainNode);

      biquadFilter2.connect(reverbMergerNode, 0, 0);
      reverbGainNode.connect(reverbMergerNode, 0, 0);
      biquadFilter2.connect(reverbMergerNode, 0, 1);
      reverbGainNode.connect(reverbMergerNode, 0, 1);

      let convolverNode2 = audioContextInstance.createConvolver();
      fetch(telephoneIR).then((res) => {
        res.arrayBuffer().then((arrayBuffer) => {
          audioContextInstance
            .decodeAudioData(arrayBuffer)
            .then((decodedBuffer) => (convolverNode2.buffer = decodedBuffer));
        });
      });
      setConvolverNode2(convolverNode2);

      let telephoneMergerNode = audioContextInstance.createChannelMerger(2);
      reverbMergerNode.connect(convolverNode2);

      let telephoneGainNode = audioContextInstance.createGain();
      telephoneGainNode.gain.setValueAtTime(
        0,
        audioContextInstance.currentTime
      );
      setTelephoneGainNode(telephoneGainNode);

      convolverNode2.connect(telephoneGainNode);

      reverbMergerNode.connect(telephoneMergerNode, 0, 0);
      telephoneGainNode.connect(telephoneMergerNode, 0, 0);
      reverbMergerNode.connect(telephoneMergerNode, 0, 1);
      telephoneGainNode.connect(telephoneMergerNode, 0, 1);

      // pannerNodeInstance.connect(mergerNodeReference,0,0)
      // pannerNodeInstance.connect(mergerNodeReference,0,1)
      let pannerNodeInstance = audioContextInstance.createStereoPanner();
      setPannerNode(pannerNodeInstance);

      telephoneMergerNode.connect(pannerNodeInstance);
      //   convolverNode.connect(pannerNodeInstance)
      pannerNodeInstance.connect(audioContextInstance.destination);

      // audioTrack.connect(audioContextInstance.destination);
    }, []);

    return (
      <Grid container direction="column" style={{ height: "100%",gridColumnStart: "1", gridRowStart: "1",minWidth:0,minHeight:0 }}>
        <Grid item direction="row" style={{ height: "74%", width: "100%" }}>

          <div onClick={(e)=>{setSelectedState(true);handelSelectionFunction(name);console.log("vocalSelected")}} style={{width:"16.5%",height:"100%", backgroundColor:(selectedState)?"#ffff0022":"",position:"relative",left:layerPosition*16.5+1+"%"}}>
          <Grid item container direction="column" className={classes.layerContainer}>
          <audio crossOrigin="anonymous" id={name} src={src}></audio>
          <Grid item className={classes.panner}>
          <Knob
                  style={{
                    display: "inline-block",
                    width: "85%",
                    height: "73%",
                    left: "5%",
                    top:"10%",
                    // transform: "translate(-14.5%, -128%)",
                    // margin: "10px",
                    position: "relative",
                  }}
                  skin={pannerKnob}
                  min={-100}
                  max={100}
                  value={panning * 100}
                  unlockDistance={50}
                  clampMin={0}
                  clampMax={310}
                  rotateDegrees={-155}
                  onChange={(value) => {
                    const maxDistance = 50;
                    let distance = Math.abs(value - panning * 100);
                    if (distance > maxDistance) {
                      return;
                    } else {
                      handelPanningChange(value / 100.0);
                    }
                  }}
                />
            {/* <Typography className={classes.layerNameTYpography}>
              {name}
            </Typography> */}
          </Grid>

          <Grid container item className={classes.muteBox}>
            <Grid item xs={1} />
            <Grid
              item
              xs={5}
              className={classes.knobGrid}
              onClick={() => handelMute(name)}
            >
              <img
                src={muted ? muteButtonOn : muteButtonOff}
                className={classes.muteControlButton}
              />
            </Grid>

            <Grid
              item
              xs={5}
              className={classes.knobGrid}
              onClick={() => handelSolo(name)}
            >
              <img
                src={solo ? soloButtonOn : soloButtonOff}
                className={classes.muteControlButton}
              />
            </Grid>
            <Grid item xs={1} />
          </Grid>

          <Grid container item className={classes.slider}>
            <div className={classes.sliderBase}>
              <Slider
                sx={{
                  '& input[type="range"]': {
                    WebkitAppearance: "slider-vertical",
                  },
                  '& .MuiSlider-track':{
                    backgroundColor:"#00ff00cc"
                  },
                  '& .MuiSlider-thumb': {

                    backgroundImage: `url(${sliderSlide})`,
                    backgroundSize: "100% auto",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundColor:"#00000000",
                    stroke:0,
                    boxShadow:"none",
                    width:"70%",
                    left:"52.5%",
                    borderRadius:0,
                    '::before':{
                      boxShadow:"none"
                    } 
                  }
                }}
                orientation="vertical"
                min={0}
                max={100}
                
                aria-label="Temperature"
                valueLabelDisplay="auto"
                value = {volume*100}
                onChange={(e)=>{
                  handelVolumeChange(e.target.value/100)
                }}
              />
              
            </div>
          </Grid>
         
        </Grid>
          </div>
        </Grid>

        <Grid
          item
          container
          direction="row"
          columns={80}
          display={selectedState ? "display" : "none"}
          style={{
            height: "26%",
            width: "97%",
            left: "1.5%",
            position: "relative",
          }}
        >
          <Grid item xs={13}>
            <div className={classes.filterResetBtn}></div>
          </Grid>
          <Grid item xs={23}>
            <Grid container className={classes.fullContainer}>
              <Grid item xs={6}>
                <Knob
                  style={{
                    display: "inline-block",
                    width: "70%",
                    height: "73%",
                    left: "14%",
                    top: "3%",
                    // top:"10%",
                    // transform: "translate(-14.5%, -128%)",
                    // margin: "10px",
                    position: "relative",
                  }}
                  skin={filterKnob}
                  min={-0}
                  max={100}
                  value={panning * 100}
                  unlockDistance={50}
                  clampMin={0}
                  clampMax={310}
                  rotateDegrees={-155}
                  // onChange={(value) => {
                  //   const maxDistance = 50;
                  //   let distance = Math.abs(value - panning * 100);
                  //   if (distance > maxDistance) {
                  //     return;
                  //   } else {
                  //     handelPanningChange(value / 100.0);
                  //   }
                  // }}
                />
              </Grid>
              <Grid item xs={6}>
                <Knob
                  style={{
                    display: "inline-block",
                    width: "70%",
                    height: "73%",
                    left: "15%",
                    top: "3%",
                    // transform: "translate(-14.5%, -128%)",
                    // margin: "10px",
                    position: "relative",
                  }}
                  skin={filterKnob}
                  min={0}
                  max={100}
                  value={reverbValue * 100}
                  unlockDistance={50}
                  clampMin={0}
                  clampMax={310}
                  rotateDegrees={-155}
                  onChange={(value) => {
                    const maxDistance = 50;
                    let distance = Math.abs(value - reverbValue * 100);
                    if (distance > maxDistance) {
                      return;
                    } else {
                      handelReverb(value);
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={44}>
            <Grid container className={classes.fullContainer}>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton value={1} onValueChange={() => {}} />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton value={2} onValueChange={() => {}} />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton value={3} onValueChange={() => {}} />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton value={4} onValueChange={() => {}} />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton value={5} onValueChange={() => {}} />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton value={6} onValueChange={() => {}} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
);

export default VocalControl;
